import styled from '@emotion/styled';
import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';
import { buttonLargeSizeStyles } from '@zola/zola-ui/src/components/ButtonV3/ButtonV3.styles';
import { COLORS3 as COLORS, FONT, MEDIA_QUERY, SPACING } from '@zola/zola-ui/src/styles/emotion';

export const TileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: fit-content;

  ${MEDIA_QUERY.TABLET} {
    height: 423px;
  }

  ${MEDIA_QUERY.DESKTOP} {
    height: 582px;
  }

  ${MEDIA_QUERY.DESKTOP_XL} {
    height: 630px;
  }
`;

export const PhotoLinkWrapper = styled.a`
  transition: all 0.2s ease-in-out;
  width: fit-content;

  ${MEDIA_QUERY.EXCLUDE_MOBILE} {
    width: auto;
  }

  ${MEDIA_QUERY.DESKTOP} {
    &:hover {
      transform: scale(1.1);
    }
  }
`;

export const StyledPicture = styled.picture`
  display: block;
  width: 240px;
  height: 240px;

  ${MEDIA_QUERY.EXCLUDE_MOBILE} {
    width: inherit;
  }

  ${MEDIA_QUERY.TABLET} {
    height: 182px;
  }

  ${MEDIA_QUERY.DESKTOP} {
    height: 182px;
  }

  ${MEDIA_QUERY.DESKTOP_LG} {
    height: 270px;
  }

  ${MEDIA_QUERY.DESKTOP_XL} {
    height: 350px;
  }
`;

export const StyledImage = styled.img`
  border-radius: 16px;
  object-fit: cover;
  object-position: left top;
  width: 100%;
  height: 100%;
`;

export const AlbumInformation = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${SPACING.XS};
  padding-top: ${SPACING.S16};

  ${MEDIA_QUERY.TABLET} {
    padding-top: ${SPACING.S24};
  }

  ${MEDIA_QUERY.DESKTOP} {
    padding-top: ${SPACING.S32};
    row-gap: ${SPACING.S16};
  }

  ${MEDIA_QUERY.DESKTOP_XL} {
    padding-top: ${SPACING.S24};
  }
`;

export const AlbumType = styled.p`
  font-size: ${FONT.FONT_SIZE_SMALLER};
  font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
  line-height: ${FONT.FONT_SIZE_REGULAR};
  margin: 0;

  ${MEDIA_QUERY.DESKTOP} {
    font-size: ${FONT.FONT_SIZE_LARGE};
    font-weight: ${FONT.FONT_WEIGHT_REGULAR};
    letter-spacing: -0.03em;
    line-height: ${FONT.FONT_SIZE_LARGER};
  }
`;

export const AlbumDescription = styled.p`
  color: ${COLORS.BLACK_075};
  font-size: ${FONT.FONT_SIZE_SMALLER};
  line-height: 150%;
  margin: 0;

  ${MEDIA_QUERY.DESKTOP} {
    font-size: ${FONT.FONT_SIZE_SMALL};
  }
`;

export const ButtonWrapper = styled.div`
  align-items: baseline;
  display: flex;
  flex-direction: column;
  margin-top: auto;
  padding-top: ${SPACING.MD};
  row-gap: ${SPACING.XS};

  ${MEDIA_QUERY.EXCLUDE_MOBILE} {
    padding-top: 0;
  }

  ${MEDIA_QUERY.DESKTOP} {
    row-gap: ${SPACING.S16};
  }
`;

export const StyledButtonV3 = styled(ButtonV3)`
  ${MEDIA_QUERY.DESKTOP} {
    ${buttonLargeSizeStyles}
  }
`;

export const AlbumPricing = styled.p`
  margin: 0;
  font-size: ${FONT.FONT_SIZE_SMALL};
  font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
`;
